import WeDoOurBit from './WeDoOurBit'

export default WeDoOurBit
